import React from 'react';
import { motion } from 'framer-motion';
export function FooterCTA() {
  return <section className="py-24 lg:py-32 relative overflow-hidden bg-brand-cream" data-id="element-1299">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/[0.06] rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1300" />
      <div className="absolute bottom-0 left-0 w-[350px] h-[350px] bg-brand-purple/[0.04] rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1301" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-1302">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-1303">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-text mb-8 leading-tight" data-id="element-1304">
            Ești pregătit/ă să faci primul pas spre o viață plină de abundență?
          </h2>

          <p className="font-subtitle text-lg md:text-xl text-brand-textSec mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-1305">
            Rezervă o sesiune gratuită de evaluare și hai să vedem împreună care
            este următorul pas potrivit pentru tine. Nu trebuie să faci totul
            singur/ă.
          </p>

          <a href="https://wa.me/40726042604?text=Bun%C4%83.%0A%0ASunt%20interesat%2F%C4%83%20de%20sesiunea%20CADOU%20de%20Claritate%20de%2030%20de%20minute.%0A%0AVreau%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20programele%20tale.%0A%0AMul%C8%9Bumesc." target="_top" className="inline-block bg-brand-gold text-white font-heading font-semibold text-lg px-10 py-5 rounded-xl hover:bg-brand-purple transition-colors duration-300 shadow-warm hover:shadow-warm-hover w-full sm:w-auto" data-id="element-1306">
            Rezervă Sesiunea Gratuită de Evaluare
          </a>
        </motion.div>
      </div>
    </section>;
}